import React, { useState } from 'react';
import AUHeader from '../components/AUHeader';
import {
  Container,
  Box,
  Typography,
  TextField,
  Button,
  CircularProgress,
  Alert,
} from '@mui/material';

const NewsletterPage = () => {
  const [nombre, setNombre] = useState('');
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle | loading | success | error
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('loading');
    setErrorMsg('');

    try {
      const backendUrl = process.env.REACT_APP_API_URL || 'http://localhost:3001';
      const res = await fetch(`${backendUrl}/api/newsletter/subscribe`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ nombre, email }),
      });
      const data = await res.json();

      if (res.ok && data.success) {
        setStatus('success');
      } else {
        setStatus('error');
        setErrorMsg(data.message || 'Hubo un error. Intenta de nuevo.');
      }
    } catch {
      setStatus('error');
      setErrorMsg('No se pudo conectar. Intenta de nuevo.');
    }
  };

  return (
    <Box>
      <AUHeader />

      <Container maxWidth="sm" sx={{ py: { xs: 6, md: 10 } }}>
        {status === 'success' ? (
          <Box sx={{ textAlign: 'center' }}>
            <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>
              Listo, quedaste registrado.
            </Typography>
            <Typography sx={{ color: 'text.secondary' }}>
              Te llegará un mail de bienvenida en los próximos minutos.
            </Typography>
          </Box>
        ) : (
          <>
            <Typography
              variant="h4"
              sx={{ fontWeight: 700, mb: 1, textAlign: 'center' }}
            >
              Newsletter de AU Coaching
            </Typography>
            <Typography
              sx={{
                color: 'text.secondary',
                textAlign: 'center',
                mb: 4,
                fontSize: '1rem',
              }}
            >
              Mails con análisis concretos para sacar tu proceso del estancamiento.
              Con estructura y programación integral estilo AU.
            </Typography>

            <Box component="form" onSubmit={handleSubmit} noValidate>
              <TextField
                label="Nombre"
                value={nombre}
                onChange={(e) => setNombre(e.target.value)}
                fullWidth
                required
                sx={{ mb: 2 }}
                disabled={status === 'loading'}
              />
              <TextField
                label="Email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                fullWidth
                required
                sx={{ mb: 3 }}
                disabled={status === 'loading'}
              />

              {status === 'error' && (
                <Alert severity="error" sx={{ mb: 2 }}>
                  {errorMsg}
                </Alert>
              )}

              <Button
                type="submit"
                variant="contained"
                fullWidth
                size="large"
                disabled={status === 'loading'}
                sx={{ py: 1.5, fontWeight: 600, fontSize: '1rem' }}
              >
                {status === 'loading' ? (
                  <CircularProgress size={24} color="inherit" />
                ) : (
                  'Suscribirme'
                )}
              </Button>
            </Box>
          </>
        )}
      </Container>
    </Box>
  );
};

export default NewsletterPage;
